import jumpTo from "jump.js";

export default {
    props: {
        query: String,
        onChange: Function,
        i18n: Object,
    },
    methods: {
        handleInput(event) {
            this.$emit('onChange', event.target.value.trim());
        },
        scrollToResults() {
            jumpTo(document.getElementById("results"), {duration: 500, offset: 0});
        }
    },
    template: `
        <div class="input-group mb-2 mb-lg-4">
            <input
                type="text"
                class="form-control form-control-sm border-top-0 border-start-0 border-end-0 ps-0 pe-2"
                :placeholder="i18n.search"
                :aria-label="i18n.search"
                aria-describedby="button-search"
                :value="query"
                @input="handleInput"
                @keyup.enter="scrollToResults"
            />
            <button @click="scrollToResults" class="btn btn-sm btn-search border-top-0 px-0 input-group-text" type="button" />
        </div>
    `
}
